exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".weui-grid.vux-grid-item-no-border:before{display:none}", ""]);

// exports
